import styled, { css } from 'styled-components';

export interface DotProps {
  size: string | number;
  color: string;
}

const toPx = (size: string | number) =>
  typeof size === 'string' ? size : `${size}px`;

export const DotStyles = ({ color, size }: DotProps) => css`
  width: ${toPx(size)};
  height: ${toPx(size)};
  border-radius: 100%;
  background-color: ${color};
`;

export default styled.div<DotProps>`
  ${(props) => DotStyles(props)}
`;
